import type { ReceiveHistoryUrlState } from './types';

export const DEFAULT_URL_STATE: ReceiveHistoryUrlState = {
  consignmentNumber: '',
  dateFrom: '',
  dateTo: '',
  search: '',
  sortBy: 'receiveDate',
  sortDir: 'ASC',
  size: '15'
};
